const mode = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'development' : 'production'
export const configuration = window.GLOBAL_CONFIGURATION[mode]
export const API = mode === 'production' ? configuration.API_HOST[window.location.hostname] : configuration.API_HOST;
export const PortalToken = window.GLOBAL_CONFIGURATION.portalToken
export const MUI_LICENSE_KEY = '419164fe34e7fb10e5ed0af765b6556fTz0xMTI1NzIsRT0xNzgwMTg1NTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'

export const Languages = {
	EL: 'el',
	EN: 'en',
}

export const Permissions = {
	AccessAdmin: "ACCESS_ADMIN"
}

export const TimeUnitsIds = {
	Days: 1,
	Min: 2,
	Hours: 3
};